import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { PermissionSetContainerModel } from 'blg-akaun-ts-lib';
import { ViewColumnState } from '../../../../application-controller/store/states/view-col.states';
import { PermissionSetModel, PermSetLine } from '../../../../models/perm-set.model';

export interface PermSetState extends EntityState<PermissionSetContainerModel> {

    newPermSet: PermissionSetModel,
    selectedPermSet: PermissionSetModel,
    selectedPermTemplate: any,
    selectedPermSetLine: PermSetLine,

    updatePermSetListing: boolean,

    selectedGuid: string;
    errorLog: {timeStamp: Date, log: string}[];
    totalRecords: number,
    requiresUpdate: boolean;
    viewCache: ViewColumnState;
}

export const permSetAdapters: EntityAdapter<PermissionSetContainerModel> = createEntityAdapter<PermissionSetContainerModel>({
    selectId: a => a.app_perm_set_hdr.guid.toString()
});

export const initialState: PermSetState = permSetAdapters.getInitialState({

    newPermSet: null,
    selectedPermSet: null,
    selectedPermTemplate: null,
    selectedPermSetLine: null,

    updatePermSetListing: false,

    selectedGuid: null,
    errorLog: [],
    totalRecords: 0,
    requiresUpdate: false,
    viewCache: null
})
